import React from 'react';

/**
 * DemoDataWarning — Red warning banner shown when query returns no data
 * but we're displaying demo visualization to show users what it would look like.
 * 
 * Business Rule: Only show when query has been tried 2+ times with 0 results.
 */
const DemoDataWarning = ({ queryLabel }) => {
  return (
    <div style={{
      background: '#FFEBEE',
      border: '2px solid #F44336',
      borderRadius: '10px',
      padding: '16px 20px',
      marginBottom: '16px',
      textAlign: 'center',
      boxShadow: '0 2px 8px rgba(244, 67, 54, 0.15)'
    }}>
      <div style={{
        fontSize: '16px',
        fontWeight: 700,
        color: '#C62828',
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px'
      }}>
        <span style={{ fontSize: '20px' }}>⚠️</span>
        <span>0 DATA RESULTS - SHOWING SIMULATED DATA VISUALIZATIONS FOR DEMO PURPOSE</span>
      </div>
      <div style={{
        fontSize: '13px',
        color: '#D32F2F',
        lineHeight: '1.5'
      }}>
        SQL query executed successfully but returned 0 rows.
        {queryLabel && <><br />Query "<strong>{queryLabel}</strong>" found no matching data in your database.</>}
        <br />
        <strong>The visualization below uses simulated data to demonstrate the chart capabilities.</strong>
      </div>
    </div>
  );
};

export default DemoDataWarning;
